/* MCR · Header recently viewed. Handles come from mcr-product.js (key mcr:recent:v1). */
(function () {
  if (customElements.get('mcr-recent')) return;
  var KEY = 'mcr:recent:v1';
  var LIMIT = 8;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]').filter(Boolean); } catch (e) { return []; }
  }
function fmtMoney(cents, format) {
    var n = cents / 100;
    var f = format || "Rs. {{amount}}";
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf("no_decimals") > -1) return Math.round(n).toLocaleString("en-IN");
      return n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }).replace(/<[^>]*>/g, "");
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  customElements.define('mcr-recent', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.mcr-recent__panel');
      this.btn = this.querySelector('.mcr-header__icon--recent');
      this.listEl = this.querySelector('[data-recent-list]');
      this.root = this.dataset.root || '/';
      if (this.root.slice(-1) !== '/') this.root += '/';
      this.cache = {};
      this.updateCount();
      var self = this;
      this.querySelectorAll('[data-recent-toggle]').forEach(function (b) {
        b.addEventListener('click', function () { self.toggle(); });
      });
      this.querySelector('[data-recent-clear]').addEventListener('click', function () {
        try { localStorage.removeItem(KEY); } catch (e) {}
        self.updateCount();
        self.render();
      });
      document.addEventListener('click', function (e) {
        if (!self.panel.hidden && !self.contains(e.target)) self.toggle(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.panel.hidden) { self.toggle(false); self.btn.focus(); }
      });
      window.addEventListener('storage', function (e) { if (e.key === KEY) self.updateCount(); });
    }

    updateCount() {
      var n = read().length;
      var bubble = this.querySelector('[data-recent-count]');
      bubble.textContent = n > 9 ? '9+' : n;
      bubble.hidden = n === 0;
    }

    toggle(force) {
      var open = typeof force === 'boolean' ? force : this.panel.hidden;
      this.panel.hidden = !open;
      this.btn.setAttribute('aria-expanded', open);
      this.classList.toggle('is-open', open);
      if (open) this.render();
    }

    money(cents) {
      return fmtMoney(cents, this.dataset.moneyFormat);
    }

    fetchProduct(h) {
      if (this.cache[h]) return Promise.resolve(this.cache[h]);
      var self = this;
      return fetch(this.root + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) self.cache[h] = p; return p; })
        .catch(function () { return null; });
    }

    render() {
      var self = this;
      var handles = read().slice(0, LIMIT);
      var empty = handles.length === 0;
      this.querySelector('[data-recent-empty]').hidden = !empty;
      this.querySelector('[data-recent-empty-link]').hidden = !empty;
      this.querySelector('[data-recent-clear]').hidden = empty;
      if (empty) { this.listEl.innerHTML = ''; return; }
      if (!this.listEl.children.length) this.listEl.innerHTML = '<li class="mcr-recent__loading">Loading…</li>';
      Promise.all(handles.map(function (h) { return self.fetchProduct(h); })).then(function (items) {
        var html = '';
        items.forEach(function (p) {
          if (!p) return;
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          var compare = p.compare_at_price > p.price ? '<s>' + self.money(p.compare_at_price) + '</s>' : '';
          html += '<li><a class="mcr-recent__item" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="64" height="80" loading="lazy">' : '<span class="mcr-recent__ph"></span>') +
            '<span class="mcr-recent__meta"><span class="mcr-recent__name">' + esc(p.title) + '</span>' +
            '<span class="mcr-recent__price">' + self.money(p.price) + ' ' + compare + '</span></span></a></li>';
        });
        self.listEl.innerHTML = html;
        self.querySelector('[data-recent-empty]').hidden = !!html;
      });
    }
  });
})();
